function homeBanner(event, remFactor = 16) {
  const e = window.matchMedia('(max-width: 991px)');

  if (document.body.classList.contains('MSDOS\\HomePage')) {
    const banner = document.querySelector('.hero-banner');
    const contentWrapper = document.querySelector('.hero-banner-content-bg');
    const container = document.querySelector('.hero-banner-content-container');
    const bannerContent = document.querySelector('.hero-banner-content');
    const bannerImage = document.querySelector('.hero-banner-image');
    const quickLinks = document.querySelector('.hero-banner-quicklinks');

    if (!quickLinks) {
      return;
    }
    const offsetHeight = bannerContent.offsetHeight;
    const offsetTop = bannerImage.offsetHeight;

    if (e.matches) {
      contentWrapper.style.height = `calc(${offsetHeight / remFactor}rem * 2)`;
      contentWrapper.style.top = `calc(${offsetTop / remFactor}rem)`;
      container.style.top = `calc(${offsetTop / remFactor}rem)`;
      banner.style.marginBottom = `calc(${offsetHeight / remFactor}rem * 1.5)`;
    } else {
      contentWrapper.style.height = 'unset';
      contentWrapper.style.top = '0';
      container.style.top = 'unset';
      banner.style.marginBottom = `unset`;
    }
  }
}

window.onresize = homeBanner;

export default homeBanner;
